<template>
  <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg8">
      <div class="sa-sesn-cont">
        <div class="sa-sesn-box-width sa-card-xs">
          <template v-if="scheduletime">
            <div class="sa-schd-week sa-h-sm-up">
              <a class="sa-sprite sa-week sa-sesn-box"><span>{{currentday}}</span></a>
            </div>
            <div class="sa-sesn-box" v-for="(item,i) in scheduletime.slots[currentday]" :key="i">
              <!-- {{item}} -->
              <i :class="item.stid=='ST0'?'icon-home':'icon-videocall'"></i>
              {{item.stid=='ST0'?'Home Visit':'Video Call'}}
              <div class="sa-sesn-box-time sa-sprite sa-mt10">{{item.strt_tym}} - {{item.end_tym}}</div>
              <a class="sa-sesn-delete" v-on:click="removeSession(currentday,i-1)">
                <span class="icon-delete1" v-if="++i==scheduletime.slots[currentday].length"></span>
              </a>
            </div>
          </template>
          <!-- <div class="sa-sesn-box sa-sesn-box-video">
                    <i class="icon-videocall"></i>
                    Video Consultation
                    <div class="sa-sesn-box-time sa-sprite sa-mt10">
                        09 : 30 AM - 01 : 30 PM
                    </div>
                    <a class="sa-sesn-delete"><span class="icon-delete1"></span></a>
          </div>-->
          <div class="sa-add-sesn-pop" v-if="addSession">
            <div class="sa-mob-header sa-h-sm-up sa-header1">
              <h5 class="sa-card-tit">Schedule</h5>
              <button class="sa-btn-back" @click="$router.go()">
                <i class="icon-left-arrow"></i>
              </button>
            </div>
          <div class="sa-row sa-mob-cont">
            <ValidationProvider name="Service type" rules="required" v-slot="{ errors }" tag="div" class="sa-col-xs12 sa-col-sm-12 sa-col-md12 sa-col-lg12">
              <div class="sa-form-group sa-sesn-group">
                <label>Visit Type</label>
                <v-select :options="options"  label="label" :reduce="d => d.id" id="visitType" name="Service type" v-model="type" rules="required|min:6" placeholder="Select"><span slot="no-options">No data</span></v-select>
              </div>
              <!-- <span class="sa-val-err sa-val-err-pos">{{ errors[0] }}</span> -->
            </ValidationProvider>
            <ValidationProvider name="Service type" rules="required" v-slot="{ errors }" tag="div" class="sa-col-xs6 sa-col-sm-6 sa-col-md6 sa-col-lg6">
              <div class="sa-form-group sa-sesn-group time">
                <label class="sa-sesn-box-time sa-sprite">Start Time</label>
              <v-select :options="startTimeArr" name="Service type" id="startTime" label="time" :reduce="d => d"  v-model="schedForm.sr" true-value="top" for="position" false-value="bottom"  @input="startTimeChange" placeholder="Select Time" append-to-body :calculate-position="withPopper"><span slot="no-options">No data</span></v-select>
              </div>
              <!-- <span class="sa-val-err sa-val-err-pos">{{ errors[0] }}</span> -->
            </ValidationProvider>
            <div class="sa-col-xs6 sa-col-sm-6 sa-col-md6 sa-col-lg6">
              <div class="sa-form-group sa-sesn-group time">
                <label class="sa-sesn-box-time sa-sprite">End Time</label>           
                <v-select :options="endTimeArr" name="End Time" id="endTimeArr"  label="time" :reduce="d => d"  v-model="schedForm.er" @input="endTimeChange"  true-value="top" for="position" false-value="bottom" placeholder="Select Time" append-to-body :calculate-position="withPopper"><span slot="no-options" >No data</span></v-select>
              </div>
            </div>
          </div>
          <div class="sa-add-sesn-btn">
            <div class="sa-row">
              <div class="sa-col-xs6 sa-col-sm-6 sa-col-md6 sa-col-lg6" v-on:click="cancelschedule">
                <button class="sa-btn sa-btn-default sa-btn-block">Cancel</button>
              </div>
              <div class="sa-col-xs6 sa-col-sm-6 sa-col-md6 sa-col-lg6">
                <button class="sa-btn sa-btn-primary sa-btn-block" v-on:click="confirmschedule">Save</button>
              </div>
            </div>
          </div>
          </div>
            <button class="sa-btn sa-add-sesn" v-on:click="addTimeSession" v-if="addSession == false && showsession">
             <i class="icon-circle-plus sa-green-text"></i> Add more session
            </button>
        </div>
        <button class="sa-btn sa-btn-large sa-btn-primary sa-schd-save-btn" v-on:click="saveschedule">Save Schedule</button>
        </div>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
  </div>
</template>
<script>
import moment, { duration } from "moment";
import { extend } from "vee-validate";
import { pro_url } from "../../../config/endpoints";
import { required, min, numeric, alpha } from "vee-validate/dist/rules";
import { createPopper } from '@popperjs/core';
extend("required", {
  ...required,
  message: "Please provide {_field_}"
});
export default {
  data() {
    return {
       placement: 'top',
      loader: false,
      options: [],
      showsun:true,
      showmon:true,
      showtue:true,
      showwed:true,
      showthu:true,
      showfri:true,
      showsat:true,
      schedForm: {
        sr: "",
        er: ""
      },
      type: "",
      addSession:false,
      startTimeArr: [],
      duration:null,
      homeVisitDuration:null,
      videoDuration:null,
      endTimeArr: [],
      startTime:"00.00",
      endTime: 50,
    };
  },
  methods: {
    withPopper (dropdownList,component, {width}){
         dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }]
      });
      return () => popper.destroy();
    },
     removeSession: function(day, index) {
      switch(day){
          case 'sun' : this.showsun =true;break;
          case 'mon' : this.showmon = true;break;
          case 'tue' : this.showtue = true;break;
          case 'wed' : this.showwed = true;break;
          case 'thu'  : this.showthu = true;break;
          case 'fri'  : this.showfri = true;break;
          case 'sat' : this.showsat = true;break
      } 
      this.scheduletime.slots[day].splice(index, 1);
    },
    saveschedule:function(){
              let wobj={
                   utid: this.scheduletime.utid,
                   slots:this.scheduletime.slots
              }
              if(this.slService && this.multi_slot == true){
                wobj.duration = this.slService
              }
              let _self = this;
              _self.loader = true
           _self.$store.dispatch('httpPost', {          
                uri: `${pro_url}/v1/addSchedule`,
                body: wobj,
            }).then(response => {
                _self.loader = false
                if (response && response.status === 1000) {
                  //  alert(response.message)
                   _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-success'})
                } else if (response && response.status == '2001'){
                  _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
                  _self.$localStorage.remove("token")
                  _self.$localStorage.remove("userdata")
                  _self.$router.push({ path: '/' })
              } else {
                    _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
                    // alert(response.message)
                }
            }).catch(e => {
                _self.$store.dispatch('SET_ALERTMESSAGE', {msg: 'Something went wrong', class: 'sa-a-danger'})
                _self.loader = false
            });
    },
    addTimeSession:function(){
      let data = this.scheduletime.slots[this.currentday]
      this.type = "";
      this.schedForm.sr = "";
      this.schedForm.er = "";
     // this.selectedday=day;
      this.addSession = true;
      this.startTimeArr = [];
      this.endTimeArr = [];
     // this.errormsg = false;
      this.startTime =
       data.length != 0 ? data[data.length - 1].end_tym : "00.00";
      /* this.currentday = day;
      this.$refs["schedForm"].clearValidate(); */
    },
    cancelschedule:function(){
      this.type='';
      this.addSession=false
    },
    confirmschedule:function(){
      if(!this.type){
      this.$store.dispatch('SET_ALERTMESSAGE', {msg: "Please Select Service Type", class: 'sa-a-danger'})
        return false
      }
      if(!this.schedForm.sr){
        this.$store.dispatch('SET_ALERTMESSAGE', {msg: "Please Select Start Time", class: 'sa-a-danger'})
        return false
      }
      if(!this.schedForm.er){
        this.$store.dispatch('SET_ALERTMESSAGE', {msg: "Please Select End Time", class: 'sa-a-danger'})
        return false
      }
      if(this.schedForm.er=='00:00'){
        switch(this.currentday){
          case 'sun' : this.showsun =false;break;
          case 'mon' : this.showmon = false;break;
          case 'tue' : this.showtue = false;break;
          case 'wed' : this.showwed = false;break;
          case 'thu'  : this.showthu = false;break;
          case 'fri'  : this.showfri = false;break;
          case 'sat' : this.showsat = false;break
        }
      }
        this.scheduletime.slots[this.currentday].push({
            stid: this.type,
            strt_tym: this.schedForm.sr,
            end_tym: this.schedForm.er
          });
          this.schedForm.sr='';
          this.schedForm.er='';
          this.addSession=false
    },
    init: function() {
      this.startTime = moment(this.startTime, "HH:mm");
      let lastEndTime = this.startTime || "00:00";
      let end2 = moment("24:00", "HH:mm");
      end2.subtract(this.duration, "minutes");
      if (this.type) {
        this.startTimeArr = this.getTimeSequence(
          lastEndTime,
          end2,
          this.duration
        );
      }
      
    },
    startTimeChange: function() {
      this.schedForm.er="";
      let startTime = moment(this.schedForm.sr, "HH:mm");
      startTime.add(this.duration, "minutes");
      let end = moment("24:00", "HH:mm");
      end.subtract(this.duration, "minutes");
      this.endTimeArr = this.getTimeSequence(startTime, end, this.duration);
      this.endTimeArr[this.endTimeArr.length] = "00:00"
      
      /* if (this.endTimeArr.length == 0) {
        this.errormsg = true;
      } else {
        this.errormsg = false;
      } */
    },
    endTimeChange: function() {
       if(this.schedForm.er=='00:00'){
        switch(this.selectedday){
          case 'sun' : this.showsun =false;break;
          case 'mon' : this.showmon = false;break;
          case 'tue' : this.showtue = false;break;
          case 'wed' : this.showwed = false;break;
          case 'thu'  : this.showthu = false;break;
          case 'fri'  : this.showfri = false;break;
          case 'sat' : this.showsat = false;break
        }
      }
      const timeSlot = {
        type: "",
        startTime: this.startTime,
        endTime: this.endTime
      };
    },
    getTimeSequence: function(start, end, duration) {
      let startTime = moment(start, "HH:mm");
      let endTime = moment(end, "HH:mm");
      if (endTime.isBefore(startTime)) {
        endTime.add("00:00", "HH:mm");
      }
      let timeStops = [];
      while (startTime <= endTime) {
        timeStops.push(new moment(startTime).format("HH:mm"));
        startTime.add(duration, "minutes");
      }
      return timeStops;
    }
  },
  computed:{
    showsession:function(){
        switch(this.currentday){
          case 'sun' : return this.showsun;break;
          case 'mon' : return this.showmon;break;
          case 'tue' : return this.showtue;break;
          case 'wed' : return this.showwed;break;
          case 'thu' : return this.showthu;break;
          case 'fri' : return this.showfri;break;
          case 'sat': return this.showsat;break;
        }
    }
  },
  watch: {
    type: function() {
      let _self = this;
      _self.schedForm.sr = "";
      _self.schedForm.er = "";
      if (_self.type) {
        switch (_self.type) {
          case "ST0":
            _self.duration = _self.homeVisitDuration;
            break;
          case "ST1":
            _self.duration = _self.videoDuration;
            break;
          case "ST2":
            _self.duration = _self.chatDuration;
            break;
        }
      }
      _self.init();
    },
    currentday:function(){
        this.addSession=false;
        this.type=false
    }
  },
  created() {
    if (this.scheduletime && this.scheduletime.duration["ST1"] != undefined) {
      this.options.push({ label: "Video Consultation", id: "ST1" });
    }
    if(this.scheduletime&&this.scheduletime.duration["ST0"]!=undefined){
      this.options.push({ label: "Home Visit", id: "ST0" });
    }
    // if (this.scheduletime && this.scheduletime.duration["ST0"] != undefined) {
    //   this.options.push({ label: "Home Visit", id: "ST0" });
    // }
     this.homeVisitDuration = this.scheduletime.duration.ST0
          ? this.scheduletime.duration.ST0
          : "";
        this.videoDuration = this.scheduletime.duration.ST1
          ? this.scheduletime.duration.ST1
          : "";
      
        if(this.scheduletime.slots.sun.length&&this.scheduletime.slots.sun[this.scheduletime.slots.sun.length-1].end_tym=="00:00"){
            this.showsun = false
       }
       if(this.scheduletime.slots.mon.length&&this.scheduletime.slots.mon[this.scheduletime.slots.mon.length-1].end_tym=="00:00"){
            this.showmon = false
       }
       if(this.scheduletime.slots.tue.length&&this.scheduletime.slots.tue[this.scheduletime.slots.tue.length-1].end_tym=="00:00"){
            this.showtue = false
       }
       if(this.scheduletime.slots.wed.length&&this.scheduletime.slots.wed[this.scheduletime.slots.wed.length-1].end_tym=="00:00"){
            this.showwed = false
       }
       if(this.scheduletime.slots.thu.length&&this.scheduletime.slots.thu[this.scheduletime.slots.thu.length-1].end_tym=="00:00"){
            this.showthu = false
       }
       if(this.scheduletime.slots.fri.length&&this.scheduletime.slots.fri[this.scheduletime.slots.fri.length-1].end_tym=="00:00"){
            this.showfri = false
       }
       if(this.scheduletime.slots.sat.length&&this.scheduletime.slots.sat[this.scheduletime.slots.sat.length-1].end_tym=="00:00"){
            this.showsat = false
       }
  },
  props: ["scheduletime", "currentday",'slService','multi_slot'],
};
</script>
